import { RiskActionListViewModel } from './riskActionListViewModel';

export class RiskActionDetailsViewModel extends RiskActionListViewModel {}
